import Modernizr from './vendors/modernizr'
import '../modules/slick-carousel';

import $ from 'jquery';

window.jQuery = $;

$('document').ready(function () {
  $('mulitple-items').slick({
    lazyLoad: 'progressive',
    // lazyLoad: 'ondemand', // could save bandwidth, but seems buggy
    dots: true,
    dotsClass: 'product__image--carousel__dots',
    appendDots: '.product__image',
    arrows: false
  });
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/lib.js